var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    alt: "Delete Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "remove-1",
    d: "M30.69,10.5a14.18,14.18,0,1,0-.1,20A14.18,14.18,0,0,0,30.69,10.5ZM11.89,29.2a12.3,12.3,0,1,1,17.4,0A12.31,12.31,0,0,1,11.89,29.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "remove-1",
    d: "M25.29,23.8,22,20.5l3.3-3.3A.92.92,0,1,0,24,15.9l-3.3,3.3-3.3-3.3a.92.92,0,0,0-1.3,1.3l3.3,3.3-3.3,3.3a.92.92,0,0,0,1.3,1.3l3.3-3.3L24,25.1a.92.92,0,1,0,1.3-1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.489b3d98.svg";
export { ForwardRef as ReactComponent };